"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isToday = exports.getCalendarDaysByWeek = void 0;
var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
var _is_same_month = _interopRequireDefault(require("date-fns/is_same_month"));
var _start_of_month = _interopRequireDefault(require("date-fns/start_of_month"));
var _start_of_week = _interopRequireDefault(require("date-fns/start_of_week"));
var _start_of_day = _interopRequireDefault(require("date-fns/start_of_day"));
var _difference_in_calendar_days = _interopRequireDefault(require("date-fns/difference_in_calendar_days"));
function cov_yt21c29pl() {
  var path = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/utils.js";
  var hash = "1954abda302909b2f259f3360cab51b564e402b5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/utils.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 37
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 12,
          column: 48
        }
      },
      "2": {
        start: {
          line: 15,
          column: 28
        },
        end: {
          line: 15,
          column: 76
        }
      },
      "3": {
        start: {
          line: 17,
          column: 17
        },
        end: {
          line: 17,
          column: 18
        }
      },
      "4": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 18
        }
      },
      "5": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 20,
          column: 89
        }
      },
      "6": {
        start: {
          line: 20,
          column: 45
        },
        end: {
          line: 20,
          column: 89
        }
      },
      "7": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "8": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 59
        }
      },
      "9": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 18
        }
      },
      "10": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 15
        }
      },
      "11": {
        start: {
          line: 28,
          column: 23
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "12": {
        start: {
          line: 29,
          column: 16
        },
        end: {
          line: 29,
          column: 38
        }
      },
      "13": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 37
          },
          end: {
            line: 10,
            column: 38
          }
        },
        loc: {
          start: {
            line: 10,
            column: 50
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 28
          }
        },
        loc: {
          start: {
            line: 20,
            column: 45
          },
          end: {
            line: 20,
            column: 89
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 23
          },
          end: {
            line: 28,
            column: 24
          }
        },
        loc: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 28
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 23
          }
        }, {
          start: {
            line: 21,
            column: 27
          },
          end: {
            line: 21,
            column: 87
          }
        }],
        line: 21
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1954abda302909b2f259f3360cab51b564e402b5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_yt21c29pl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_yt21c29pl(); // date helpers
// return a list of week that is a table of days to display in the calendar, based on the first and the last days to show.
cov_yt21c29pl().s[0]++;
var getCalendarDaysByWeek = exports.getCalendarDaysByWeek = function getCalendarDaysByWeek(monthDate) {
  cov_yt21c29pl().f[0]++;
  // for the calendar date, get the first date in the month
  var firstMonthDate = (cov_yt21c29pl().s[1]++, (0, _start_of_month.default)(monthDate));
  // maybe the start of the week is not in the month, so take the first day of week.
  // To get the monday, you need to pass 1 to weekStartsOn
  var firstCalendarDate = (cov_yt21c29pl().s[2]++, (0, _start_of_week.default)(firstMonthDate, {
    weekStartsOn: 1
  }));
  // prepare the list of calendarDays, define the number of days needed depending of the month
  var nbOfDays = (cov_yt21c29pl().s[3]++, 0);
  var weeks = (cov_yt21c29pl().s[4]++, []);
  // for each week generate the days
  cov_yt21c29pl().s[5]++;
  var generateWeekDays = function generateWeekDays(value, index) {
    cov_yt21c29pl().f[1]++;
    cov_yt21c29pl().s[6]++;
    return (0, _add_days.default)(firstCalendarDate, index + nbOfDays);
  };
  cov_yt21c29pl().s[7]++;
  while ((cov_yt21c29pl().b[0][0]++, nbOfDays === 0) || (cov_yt21c29pl().b[0][1]++, (0, _is_same_month.default)((0, _add_days.default)(firstCalendarDate, nbOfDays), monthDate))) {
    cov_yt21c29pl().s[8]++;
    weeks.push((0, _from.default)(new Array(7), generateWeekDays));
    cov_yt21c29pl().s[9]++;
    nbOfDays += 7;
  }
  cov_yt21c29pl().s[10]++;
  return weeks;
};
cov_yt21c29pl().s[11]++;
var isToday = exports.isToday = function isToday(date) {
  cov_yt21c29pl().f[2]++;
  var today = (cov_yt21c29pl().s[12]++, (0, _start_of_day.default)(new Date()));
  cov_yt21c29pl().s[13]++;
  return (0, _difference_in_calendar_days.default)(date, today) === 0;
};